import createContextProxy from 'src/state/context/contextProxy'
import type { MeetingsStateType } from './MeetingsStateProvider'

const meetingsStateProvider = createContextProxy<MeetingsStateType>('Content')

export const MeetingsStateContext = meetingsStateProvider.ContextProxy
export const MeetingsStateProvider = meetingsStateProvider.ContextProxyProvider
export const useMeetingsState = meetingsStateProvider.useProxy
